/**
 * @generated SignedSource<<ada72d05342b6665a5f8270f801a9be3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleSourceHeaderArticle$data = {
  readonly urlAlias: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "articleSourceHeaderArticle";
};
export type articleSourceHeaderArticle$key = {
  readonly " $data"?: articleSourceHeaderArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleSourceHeaderArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleSourceHeaderArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "a1dc060c3045dd627b976d5efe6dd83d";

export default node;
